<app-temp-modal-cadastro #modal (closed)="onClose()" [textHeader]="'Documentos Anexados a Movimentação'"
  [customClass]="'modal-lg'">
  <div class="app-modal-body">
    <div class="row">
      <div class="form-group col-sm-12 mb-0">
        <app-dim-datatable *ngIf="documentosAnexos.length > 0" [loading]="loading['request']" [serverPaginated]="false"
          [columns]="colunasDocumentosAnexos" [data]="documentosAnexos" [rowsOnPage]="10"
          [totalItems]="documentosAnexos.length" [acoes]="true">
          <ng-template #buttonsMaxTmpl let-row="row">
            <button [disabled]="loading['request'] || !row.id || loading['downloadAnexo']"
              class="btn btn-info btn-mini waves-effect waves-light" style="border-radius: 10%" type="button"
              placement="left" ngbTooltip="Baixar documento" (click)="downloadProdutoDocumentoAnexo(row)">
              <app-loading [loading]="loading['downloadAnexo']" [icone]="'icofont icofont-download-alt'" [texto]="' '"
                [textoLoading]="' '" />
            </button>
          </ng-template>
        </app-dim-datatable>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <button class="btn btn-info" (click)="fechar()" [disabled]="loading['acoes']">
          Fechar
        </button>
      </div>
    </div>
  </div>
</app-temp-modal-cadastro>